<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5>Gain Converter</h5>
        <div v-if="item && item.ffmpeg_details.volume" class="data-box">
          <div class="row">
            <div class="col-12 col-sm-6 current-data">
              <h4>Current Data</h4>
              <p><strong>Mean Volume:</strong> {{ item.ffmpeg_details.volume.mean_volume }} dB</p>
              <p><strong>Max Volume:</strong> {{ item.ffmpeg_details.volume.max_volume }} dB</p>
            </div>
            <div v-if="preview && previewFfmpegData" class="col-12 col-sm-6 preview-data">
              <h4>Preview Data</h4>
              <p><strong>Mean Volume:</strong> {{ previewFfmpegData.volume.mean_volume }} dB</p>
              <p><strong>Max Volume:</strong> {{ previewFfmpegData.volume.max_volume }} dB</p>
              <small>Volume data only applies to the 10 second preview. This wont be the same for the whole track</small>
            </div>
          </div>
        </div>
        <div v-else class="data-box">
          <p>There is currently no volume data for this file</p>
          <button class="btn btn-ss-standout" @click="generateVolumeData()">
            Generate Volume Data
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-3 col-md-4 gain-input">
        <div class="input-group kt-input-group kt-input-group--square">
          <div class="input-group-prepend">
            <span id="basic-addon1" class="input-group-text">%</span>
          </div>
          <input id="m_nouislider_gain_input" v-model="newVolume"
                 type="text"
                 class="form-control kt-input" placeholder="Gain">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 gain-slider">
        <div id="m_nouislider_gain" class="kt-nouislider--drag-danger" />
      </div>
    </div>
    <div class="row preview-container">
      <div class="col-12 col-sm-6 col-md-5">
        <form class="kt-form kt-form--fit">
          <label class="control-label">Create a 10 second preview start from : </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-clock time" /></span>
            </div>
            <input
              id="preview-from"
              v-model="previewFrom"
              v-validate="'is_time|within_duration|required'"
              v-mask="'##:##:##'"
              name="preview-from"
              type="text"
              class="form-control kt-input"
              placeholder="00:00:00">
            <div class="input-group-append">
              <button class="btn btn-secondary btn-generate-preview mt-ladda-btn ladda-button" data-style="expand-right" @click="generatePreview">
                <span class="ladda-label">Generate Preview</span>
              </button>
            </div>
          </div>
          <span v-show="errors.has('preview-from')" class="text-ss-danger">{{ errors.first('preview-from') }}</span>
        </form>
      </div>
      <div v-if="preview" class="col-12 col-sm-6 col-md-7">
        <label class="control-label">Preview </label>
        <div class="input-group preview">
          <audio controls>
            <source :src="preview">
          </audio>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="kt-form__group form-group mt-2">
          <div class="d-flex flex-column">
            <ss-checkbox id="create-new-file" v-model="newFileChecked">
              Create New File
            </ss-checkbox>
          </div>
        </div>
      </div>
      <div class="col-12">
        <button class="btn btn-ss-standout btn-modify-gain mt-ladda-btn ladda-button" data-style="expand-right" @click="modifyGain">
          <span class="ladda-label">Modify Gain</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import VeeValidate from "vee-validate";
import VueTheMask from "vue-the-mask";
import Ladda from "ladda";
import "ladda/dist/ladda-themeless.min.css";

Vue.use(VueTheMask);
Vue.use(VeeValidate, { fieldsBagName: "formFields" });

export default {
  name: "Gain",
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    gainSlider: null,
    newDb: null,
    newVolume: 0,
    newFileChecked: 1,
    preview: null,
    previewFfmpegData: null,
    previewFrom: "00:00:00",
  }),
  watch: {
    ffmpegData() {
      VeeValidate.Validator.extend("within_duration", {
        // Custom validation message
        getMessage: () => `Value exceeds duration`,
        // Custom validation rule
        validate: value =>
          new Promise((resolve) => {
            const a = value.split(":"); // split it at the colons
            // minutes are worth 60 seconds. Hours are worth 60 minutes.
            const value_in_seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
            // Previews are 10 seconds long - so make sure the starting point is at least 10 seconds before end of track
            const max_start = this.ffmpegData.duration - 10;
            resolve({
              valid: value && value_in_seconds < max_start,
            });
          }),
      });
    },
  },

  mounted() {
    const vm = this;
    $(document).ready(() => {
      vm.initSlider();
    });
  },
  methods: {
    initSlider() {
      const vm = this;
      // init slider
      const slider = document.getElementById("m_nouislider_gain");

      window.noUiSlider.create(slider, {
        start: [100],
        range: {
          min: [0],
          max: [200],
        },
        pips: {
          mode: "values",
          values: [0, 50, 100, 150, 200],
          density: 4,
        },
      });

      // init slider input
      const slider_input = document.getElementById("m_nouislider_gain_input");

      // When someone drags the slider, update the input value
      slider.noUiSlider.on("update", (values, handle) => {
        vm.newVolume = values[handle];
      });

      // When someone enters a value into the input box - update the slider value
      slider_input.addEventListener("change", function () {
        vm.newVolume = this.value;
        slider.noUiSlider.set(this.value);
      });
    },
    convertToSeconds(time) {
      const a = time.split(":"); // split it at the colons
      // minutes are worth 60 seconds. Hours are worth 60 minutes.
      return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    },

    generateVolumeData() {
      axios.post(`/api/v1/storage/${this.item.uuid}/detect-volume`).then(() => {
        toastr.success("Retrieved Volume data, reloading page...");
        location.reload();
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
    modifyGain() {
      this.submitLadda = Ladda.create(document.querySelector(".btn-modify-gain"));
      this.submitLadda.start();
      axios
        .post(`/api/v1/storage/${window.item.uuid}/modifyGain`, {
          new_file: this.newFileChecked,
          volume: this.newVolume,
        })
        .then((response) => {
          if (response.data) {
            if (!this.newFileChecked) {
              toastr.success("Gain modified");
              location.reload();
            } else {
              toastr.success(
                "New file at modified gain level created. Return to storage to view.",
              );
            }
          }
          this.submitLadda.stop();
        })
        .catch((error) => {
          window.handleAxiosError(error);
          this.submitLadda.stop();
        });
    },

    generatePreview() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitLadda = Ladda.create(
            document.querySelector(".btn-generate-preview"),
          );
          this.submitLadda.start();
          this.preview = null;
          axios
            .post(`/api/v1/storage/${window.item.uuid}/previewGain`, {
              volume: this.newVolume,
              start_from: this.convertToSeconds(this.previewFrom),
            })
            .then((response) => {
              if (response.data) {
                this.preview = response.data.data.preview_path;
                this.previewFfmpegData = response.data.data.ffmpegData;
                toastr.success('Preview Generated');
              }
              this.submitLadda.stop();
            })
            .catch((error) => {
              window.handleAxiosError(error);
              this.submitLadda.stop();
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h4 {
  margin-bottom: 10px;
}

.preview {
  margin-top: 2px;
}

.gain-input {
  margin-bottom: 20px;
}

.gain-slider {
  margin-bottom: 40px;
}

.new-file-checkbox {
  margin-top: 8px;
}

.preview-container {
  margin-top: 20px;
}
</style>
